import React from 'react';

import {Icon, Link} from '../components';
import {Text} from '../components/common';
import {thinMargins} from '../constants';
import {
  StructuredText,
  StructuredTextDocument,
} from 'react-datocms/structured-text';

export const CategoryHeader = ({
  context,
  categoryTitle,
  categoryDescr,
  isParents = false,
}: {
  context: 'Learn' | 'Ask';
  categoryTitle: string;
  categoryDescr?: StructuredTextDocument;
  isParents?: boolean;
}) => {
  return (
    <div className={`pt-24 lg:pt-28 pb-6 lg:pb-10 bg-background`}>
      <div className={`${thinMargins}`}>
        {isParents ? (
          <Link linkTo="parents/guides">
            <div className="flex items-center gap-4 pb-2">
              <Icon iconName={'left'} height={40} width={40} />
              <Text as="p" variant="SmallBody" className="hover:underline">
                Parent guides
              </Text>
            </div>
          </Link>
        ) : (
          <Link linkTo={context === 'Learn' ? 'articles' : 'questions'}>
            <div className="flex items-center gap-4 pb-2">
              <Icon iconName={'left'} height={40} width={40} />
              <Text as="p" variant="SmallBody" className="hover:underline">
                {context === 'Learn' ? 'Article library' : 'Question library'}
              </Text>
            </div>
          </Link>
        )}
        <Text as="h1" variant="LargeTitle" className="pt-6">
          {categoryTitle}
        </Text>
        {categoryDescr && (
          <Text as="div" variant="SmallBody" className="pt-4">
            <StructuredText data={categoryDescr} />
          </Text>
        )}
      </div>
    </div>
  );
};
